// extracted by mini-css-extract-plugin
export var standaloneTable = "_h5-0";
export var withExtraHeader = "_h5-1";